module.exports = __webpack_public_path__ + "media/images/download-705ad126cc6d8443b978890560e86ece.svg";